import { createContext, useContext } from "react";
export const AppContext = createContext();

export let updateContext;

export const useAppContext = () => {
  const { contextData, setContextData } = useContext(AppContext);

  updateContext = (key, value) => {
    setContextData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return {
    contextData,
    setContextData,
    updateContext,
  };
};
